import ContactStore from '../stores/pages/contactStore'
import AccountStore from '../stores/pages/accountStore'
import BillsToPayStore from '../stores/pages/billsToPayStore'
import TransactionStore from '../stores/pages/transactionStore'

export default {ContactStore,AccountStore,BillsToPayStore,TransactionStore}
